




























































































































import Vue, { PropOptions } from 'vue';
import { mapGetters, mapState } from 'vuex';

import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import ProductCard from '@/web/components/products/ProductCard.vue';
import ProductState from '@/core/typings/enums/ProductState';
import CreateProductModal from '@/web/components/products/CreateProductModal.vue';
import draggable from 'vuedraggable';
import { draggableDelay } from '@/web/utils/draggable';
import { isEmpty, values } from 'lodash';

interface LocalState {
  draggableDelay: number;
  tab: string;
  search: string;
  localTeacherProducts: ProductResponse[] | null;
  isLoading: boolean;
}
interface LocalProps {
  foo: PropOptions;
}

export default Vue.extend({
  name: 'MyProduct',
  data(): LocalState {
    return {
      draggableDelay,
      tab: 'all-products',
      search: '',
      localTeacherProducts: null,
      isLoading: true,
    };
  },
  components: {
    TopNav,
    NavItem,
    ProductCard,
    draggable,
  },
  computed: {
    ...mapGetters({
      teacherProducts: 'product/teacherProducts',
    }),
    ...mapState('product', ['teacherProductsFilter']),
    isNoData() {
      return (
        !this.isLoading &&
        !this.teacherProducts?.length &&
        values(this.teacherProductsFilter).every(isEmpty)
      );
    },
    publishedProducts() {
      if (!this.teacherProducts) return [];
      return this.teacherProducts.filter(
        product => product.productState === ProductState.Published
      );
    },
    draftProducts() {
      if (!this.teacherProducts) return [];
      return this.teacherProducts.filter(
        product => product.productState === ProductState.Draft
      );
    },
    hiddenProducts() {
      if (!this.teacherProducts) return [];
      return this.teacherProducts.filter(
        product => product.productState === ProductState.Hidden
      );
    },
    privateSpaceProducts() {
      if (!this.teacherProducts) return [];
      return this.teacherProducts.filter(
        product => product.productState === ProductState.PrivateSpaces
      );
    },
    archiveProducts() {
      if (!this.teacherProducts) return [];
      return this.teacherProducts.filter(
        product => product.productState === ProductState.Archive
      );
    },
  },
  methods: {
    containsElements(array) {
      if (!array) return false;
      return array?.length > 0;
    },
    getProductState(value: string): ProductState | null {
      switch (value) {
        case 'published':
          return ProductState.Published;
        case 'private_space':
          return ProductState.PrivateSpaces;
        case 'hidden':
          return ProductState.Hidden;
        case 'draft':
          return ProductState.Draft;
        case 'archived':
          return ProductState.Archive;
        default:
          return null;
      }
    },
    openProductDetail(product: ProductResponse): void {
      this.$router.push(`/products/${product.id}/`);
    },
    addProduct(): void {
      this.$modal.show(CreateProductModal);
    },
    async loadProducts() {
      this.isLoading = true;
      await this.$store.dispatch('product/getTeacherProducts');
      this.localTeacherProducts = this.publishedProducts;
      this.isLoading = false;
    },
  },
  async mounted() {
    await this.$store.dispatch('product/setTeacherProductsFilter');
    await this.loadProducts();
  },
  watch: {
    localTeacherProducts: {
      handler(values: ProductResponse[]) {
        const updates = values
          .map((v, i) => ({ id: v.id, position: i }))
          .filter((item, i) => values[i].position !== item.position);
        if (updates.length) {
          this.$store.dispatch('product/reorderProducts', updates);
        }
        this.$store.dispatch('product/setTeacherProducts', [
          ...values,
          ...this.draftProducts,
          ...this.hiddenProducts,
          ...this.privateSpaceProducts,
          ...this.archiveProducts,
        ]);
      },
    },
    tab() {
      this.$store.dispatch('product/setTeacherProductsFilter', {
        q: this.search,
        productState: this.getProductState(this.tab),
      });
    },
    search() {
      this.$store.dispatch('product/setTeacherProductsFilter', {
        q: this.search,
        productState: this.getProductState(this.tab),
      });
    },
  },
});
